import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { makeGetSortedActiveTeams, makeGetCurrentTeam } from 'selectors/teams';

import { setMasterToken } from 'actions/auth';

import { switchTeam } from 'globals-service';

import { useCanLogin } from 'shared-hooks/auth';

import Tooltip from 'components/tooltip';
import AvatarBase from 'components/avatar-base';
import CanUser from 'components/can-user';

import './TeamsList.styles.css';

const TeamEntry = ({ team, masterToken, loginRestrictedSSO, onClick, onEditClick }) => {
    const { t } = useTranslation('onboarding');
    const canLogin = useCanLogin(team);

    const handleClick = () => {
        if (!canLogin) {
            return;
        }

        onClick(team.url, masterToken);
    }

    const handleEditClick = () => {
        if (!canLogin) {
            return;
        }

        onEditClick('current');
    }

    return (
        <Tooltip
            disabled={canLogin}
            placement="right"
            tooltip={t('ssoOnly')}
        >
            <div className={'teams-list-entry' + (team.is_current ? ' current' : '') + (!canLogin ? ' disabled' : '')}>
                {
                    !team.is_current ? (
                        <div className="item-overlay" onClick={handleClick} />
                    ) : null
                }

                <div className="item-head">
                    <AvatarBase image={team.logo} color={team.color} foregroundColor={team.secondary_color} text={team.initials} solidImage={true} />
                </div>

                <div className="item-body">
                    { team.name }
                </div>

                {

                    onEditClick && team.is_current ? (
                        <CanUser type="viewTeamSettings">
                            <div className="item-foot">
                                <button className="btn" onClick={handleEditClick}>
                                    <i className="ion ion-ios-gear" />
                                </button>
                            </div>
                        </CanUser>
                    ) : null
                }
            </div>
        </Tooltip>
    )
}

const TeamsList = ({ type = 'list', teams, linkedTeams, showDirectTeams, showLinkedTeams, withSwitch, withEdit, onTeamSelect, onEditTeam }) => {
    const history = useHistory();
    const location = useLocation();

    const handleEditTeamClick = teamId => {
        history.push({
            pathname: `/settings/team/${teamId}`,
            state: {
                closeUrl: location.pathname
            }
        });

        onEditTeam && onEditTeam();
    }

    const handleTeamClick = (teamUrl, masterToken) => {
        if (withSwitch) {
            if (masterToken) {
                setMasterToken(masterToken);
            }

            switchTeam({ teamUrl });
        }

        onTeamSelect && onTeamSelect(teamUrl, masterToken);
    }

    return (
        <div className={`teams-list type-${type}`}>
            {
                showDirectTeams && teams.map((team, index) => <TeamEntry
                    key={team.id || index}
                    team={team}
                    onClick={handleTeamClick}
                    onEditClick={withEdit && handleEditTeamClick}
                />)
            }

            {
                showLinkedTeams && (linkedTeams || []).map(account => (
                    <div key={account.id} className="teams-group">
                        <h5>{ account.name }</h5>

                        {
                            account.teams.map((team, index) => <TeamEntry
                                key={team.id || index}
                                team={team}
                                masterToken={account.master_token}
                                onClick={handleTeamClick}
                                onEditClick={withEdit && handleEditTeamClick}
                            />)
                        }
                    </div>
                ))
            }
        </div>
    )

}

const makeMapStateToProps = () => {
    const getSortedActiveTeams = makeGetSortedActiveTeams();

    return ({ teams }) => {
        return {
            teams: getSortedActiveTeams(teams.items),
            linkedTeams: teams.linkedTeams
        }
    };
}

export default connect(makeMapStateToProps)(TeamsList);
